<template>
  <div>
     <div class="p-s-cen">
        <img class="p-s-img" :src="cdnUrl + imgUrl" alt="">
    </div>
    <div class="p-s-detail" v-show="introLength > 0">
        <div class="p-r-content">
            <div class="p-r-info" :class="clickMore?'':'van-multi-ellipsis--l2'" v-html="detail.jianjie"></div>
            <button class="bottom-btn-more" @click="moreContent" v-show="introLength >= 50">{{clickMore?'收起':'更多'}}</button>
        </div>
    </div>
    <div class="p-s-menu-main">
        <ul class="p-s-menu">
            <li @click="handleMenu('1')" :class="menuType == '1'? 'active': ''">介绍</li>
            <li @click="handleMenu('2')" :class="menuType == '2'? 'active': ''">视频</li>
        </ul>
    </div>
    <div class="p-s-d" v-show="menuType == '1'" v-html="detail.desc"></div>
    <!-- 视频 -->
    <relevantVideo v-show="menuType == '2'" :productVideo="productMaterial" :id="id" @videoChange="videoChange"></relevantVideo>
     <!-- 视频播放 -->
    <video-play ref="videoPlay"></video-play>
  </div>
</template>

<script>
import { getProductDetails } from '@/api/product'
import relevantVideo from './components/relevantVideo.vue'
import DPlayer from 'dplayer'
import { centrifugeRecord } from '@/libs/common'
import videoPlay from '@/components/videoPlay'
export default {
    components:{relevantVideo,videoPlay},
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            id: '',
            introLength: 0,
            clickMore: false,
            imgUrl: '',
            detail: {},
            productMaterial: {
                video: []
            },
            menuType: '1',
            showVideo: false
        }
    },
    created() {
        this.id = this.$route.query.id
        this.getDetail()
        
    },
    methods: {
        getDetail() {
            getProductDetails({id: this.id}).then(res => {
                
                this.imgUrl = JSON.parse(res.data.img_url)[0]
                this.detail = res.data
                res.data.jianjie? this.introLength = res.data.jianjie.length : 0
                this.productMaterial.video = res.data.video || []
            })
        },
        videoChange (item) {
            var videoUrl = JSON.parse(item.video_url)
            this.videoUrl = videoUrl[0]
            this.$refs.videoPlay.dplayerOption(`${this.cdnUrl + this.videoUrl}`)
        },
        handleMenu(type) {
            this.menuType = type
            let para = {
                type: type == '1'? 32 : 33, // 32 介绍 33 视频
                uid: this.$store.state.user.id || 0,
                action: 1,
                type_id: 0
            }
            centrifugeRecord(para)
        },
        moreContent () {
            this.clickMore = !this.clickMore
        },
    }
}
</script>

<style lang="scss">
.p-s-cen {
    display: flex;
    justify-content: center;
    .p-s-img {
        width: rem(343);
        height: rem(179);
        margin-top: rem(12);
        border-radius: rem(6);
    }
}
.p-s-detail {
    overflow: hidden;
    padding: rem(20);
    box-sizing: border-box;
    .p-r-content {
        background: #dee5ed;
        padding: rem(10) rem(20) rem(20);
        border-radius: 2px;
        .p-r-info{
            color: #333333;
            font-size: 12px;
            line-height: rem(20);
            word-break: break-word;
        }
        .van-multi-ellipsis--l2{
            transition: all .2s;
        }
    }
}
.p-s-menu-main {
    display: flex;
    justify-content: center;
    margin-top: rem(12);
    .p-s-menu {
        width: rem(343);
        height: rem(30);
        display: flex;
        justify-content: center;
        // align-items: center;
        border-radius: 4px;
        color: #6CC5DB;
        border: 1px solid #6C94DB;
        li {
            flex: 1;
            line-height: rem(30);
            text-align: center;
        }
        .active {
            color: #fff;
            background-color: #6CC5DB;
            border-radius: 4px;
        }
    }
}
.p-s-d {
    padding: rem(20);
    img {
        width: 100%;
    }
}
.bottom-btn-more{
    width: rem(72);
    height: rem(28);
    display: block;
    margin: 0 auto;
    margin-top: rem(20);
    border: 1px solid #2c2c2c;
    font-size: 13px;
    background: none;
    color: #2c2c2c;
    border-radius: 2px;
}
</style>